import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, UsersApi, UserViewEntity } from '@shared/api';

interface IUsersStore {
  loading: boolean;
  error: string | null;
  users: UserViewEntity[];
  getUsers: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useUsersStore = create<IUsersStore>((set) => ({
  loading: false,
  error: null,
  users: [],

  getUsers: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await UsersApi.getUsers(signal);
      set({ users: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ users: [], loading: false, error: null }),
}));
